import { useTokenBuys } from '@entities/trades/token-buy';
import type { ITokenBuyTableColumns } from '@entities/trades/token-buy';
import { useRefetchAuto } from '@features/refetch-auto';
import ErrorMessage from '@shared/components/ErrorMessage';
import Loading from '@shared/components/Loading';
import LoadingSpinner from '@shared/components/LoadingSpinner';
import { Pagination, PaginationRows } from '@shared/components/Pagination';
import { Table, THead, TBody, TableContainer, TableProvider } from '@shared/components/Table';

import { useTableSettings } from './settings/useTableSettings';

const TokenBuysWidget = () => {
  const { refreshInterval, setRefreshInterval } = useRefetchAuto({
    storageKey: 'refetch-auto-token-buys',
  });

  const {
    tokenBuys,
    isLoading,
    isError,
    error,
    isFetching,
    refetch,

    filter,
  } = useTokenBuys({ refreshInterval });

  const { columnTitles, renderRow, renderFilterElement, getTheadAfter, getTbodyAfter } =
    useTableSettings({
      refetch,
      refreshInterval,
      setRefreshInterval,
    });

  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorMessage error={error} />;

  if (tokenBuys) {
    return (
      <>
        {isFetching && <Loading />}

        <TableProvider<ITokenBuyTableColumns>
          columnTitles={columnTitles}
          storageKey='token-buys'
          {...filter}
        >
          <TableContainer>
            <Table>
              <THead
                items={tokenBuys.data}
                renderItem={renderFilterElement}
                afterColumns={getTheadAfter}
              />
              <TBody
                items={tokenBuys.data}
                renderItem={renderRow}
                afterColumns={getTbodyAfter}
              />
            </Table>
          </TableContainer>
          <div className='pagination-container'>
            <Pagination data={tokenBuys.meta} />
            <PaginationRows />
          </div>
        </TableProvider>
      </>
    );
  }

  return null;
};

export default TokenBuysWidget;
